import React, { useEffect, useState } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Image from "../Image/Image.tsx";
import Tooltip from "../Tooltip/Tooltip.js";

const RadioOption = ({
  register,
  getValues,
  refObject,
  item,
  option,
  handleChange,
}) => {
  const { getTextByKey } = useContent();

  const [hover, setHover] = useState(false);

  return (
    <div
      className="radio-option"
      key={option.value}
      onMouseEnter={() => {
        setHover(true);
      }}
      onMouseLeave={() => {
        setHover(false);
      }}
      onClick={() => {
        handleChange({ value: option.value });
      }}
    >
      <label>
        <input
          className={`input-field`}
          type="radio"
          value={option.value}
          {...register(item.fieldKey, refObject)}
        />
        <Image
          name={
            getValues()[item.fieldKey] === option.value
              ? "radio-checked"
              : "radio-unchecked"
          }
          className="radio-icon"
        />
        {option.icon && (
          <Image
            src={option.icon}
            alt={option.value}
            className="radio-title-image"
          />
        )}
        {option.label && <span>{getTextByKey(option.label)}</span>}
      </label>
      {hover && option.tooltipTextKey ? (
        <Tooltip id={option.value} tooltipTextKey={option.tooltipTextKey}>
          <div className="radio-tooltip-icon">?</div>
        </Tooltip>
      ) : null}
    </div>
  );
};

const RadioField = ({
  item,
  register,
  getValues,
  setValue,
  refObject,
  errors,
  defaultSelect,
  labelClassName = "",
}) => {
  const { getTextByKey } = useContent();

  const handleChange = (selectItem) => {
    setValue(item.fieldKey, selectItem.value);
  };

  useEffect(() => {
    if (defaultSelect) {
      setTimeout(() => {
        handleChange(defaultSelect);
      }, 100);
    }
  }, []);

  return (
    <label
      className={`radio-lable ${errors[item.fieldKey] ? "invalid-input" : ""}`}
    >
      <div className={`input-label ${labelClassName}`}>
        {getTextByKey(item.label)}
      </div>
      <div className="radio-options-container">
        {item.optionsList.map((option) => (
          <RadioOption
            {...{ option, item, register, getValues, refObject, handleChange }}
            key={option.value}
          />
        ))}
      </div>
    </label>
  );
};

export default RadioField;
